/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Metric_UnavailableInputs */

const en_directory_home_hero_metric_unavailable = /** @type {(inputs: Directory_Home_Hero_Metric_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not measured`)
};

const zh_directory_home_hero_metric_unavailable = /** @type {(inputs: Directory_Home_Hero_Metric_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未测量`)
};

/**
* | output |
* | --- |
* | "Not measured" |
*
* @param {Directory_Home_Hero_Metric_UnavailableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_metric_unavailable = /** @type {((inputs?: Directory_Home_Hero_Metric_UnavailableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Metric_UnavailableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_metric_unavailable(inputs)
	return zh_directory_home_hero_metric_unavailable(inputs)
});
export { directory_home_hero_metric_unavailable as "directory.home.hero.metric_unavailable" }